import React, { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { PaginationTemplate } from '../../components/templates';
import services from '../../services';
import EmpresasItem from './_components/EmpresasItem';
import EmpresasTerms from './_components/EmpresasTerms';
import EmpresasSetorFilter from './_components/EmpresasSetorFilter';
import { resolveEmpresasListSort, sanitizeEmpresasListParams } from './_shared/empresasFilterQuery';
import { getEmpresasSetorRouteContext } from './_shared/empresasSetorRoute';

/**
 * Lista somente as empresas pertencentes ao setor definido pela rota.
 *
 * @returns {JSX.Element} Listagem paginada do setor ou redirecionamento para a entrada.
 */
const EmpresasSetor = memo(() => {
  const xLocation = useLocation();
  const { route: xRoute, setor: xSetor } = getEmpresasSetorRouteContext(xLocation.pathname);

  if (!xSetor) {
    return <Navigate replace to="/empresas" />;
  }

  /** Impõe o setor da rota na listagem e nas sugestões da busca interna. */
  function pvList(pParams, pResolve, pReject, pFinally) {
    const xParams = sanitizeEmpresasListParams(pParams);

    xParams.sort = resolveEmpresasListSort(xParams.sort, Boolean(xParams.pesquisa), true);

    return services.pesquisas.pessoa(
      { ...xParams, top_setor_id: xSetor.setor_id },
      pResolve,
      pReject,
      pFinally
    );
  }

  return (
    <PaginationTemplate
      id="empresas"
      title="Empresas"
      description={xSetor.metadata.description}
      dataRead={pvList}
      dataReadParams={{ cancelado: 'null' }}
      filterComponent={EmpresasSetorFilter}
      filterVariant="searchFilters"
      termsComponent={EmpresasTerms}
      listItem={EmpresasItem}
      listItemKey="pessoa_id"
      listItemProps={{ pathnameBase: '/empresas', showSetor: true }}
      pageSize={25}
      match={`empresas/${xRoute}/*`}
      maxWidth="xl"
    />
  );
});

EmpresasSetor.displayName = 'EmpresasSetor';

export default EmpresasSetor;
